<template>
  <div class="show-password-icon" @click="switchPasswordInputType($event)">
    <font-awesome-icon :icon="buttonIcon" style="pointer-events: none;" />
  </div>
</template>

<script>
export default {
  name: 'ShowPasswordIcon',
  data () {
    return {
      isOpen: true
    }
  },
  props: {
    inputId: {
      type: String,
      default: null
    }
  },
  computed: {
    buttonIcon () {
      return (this.isOpen) ? 'fa-regular fa-eye' : 'fa-regular fa-eye-slash' 
    }
  },
  methods: {
    switchPasswordInputType (event) {
      this.isOpen = !this.isOpen
      // by default get the previous element
      let passwordField = event.target.previousElementSibling
      if (this.inputId) {
        passwordField = document.getElementById(this.inputId)
      }
      
      if (passwordField && passwordField.tagName === 'INPUT') {
        passwordField.type = passwordField.type === 'password' ? 'text' : 'password'
      }
    }
  },
}
</script>

<style lang="scss" scoped>
  .show-password-icon {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 0.5rem;
    transform: translateY(-50%) scaleX(-1); // (-1) swap horizontally, for the slash icon direction
    display: flex;
    opacity: 0.3;
    font-size: 15px;
  }
</style>